import { Rotate, Fade } from 'react-reveal';
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setTabData } from "../../redux/programs/ProgramsAction";

import CustomButton from "../../components/CustomButton";
import InPersonImageGroup from "./inPersonImageGroup";

import CONSTANTS from "../../utils/constants/CONSTANTS";

import "./index.scss";

const InPersonWorkout = () => {
  const dispatch = useDispatch();
  const handleTab = () => {
    dispatch(setTabData(CONSTANTS.TABS.IN_PERSON));
    window.scrollTo(0, 0);
  };
  return (
    <div className="inperson-container">
      <Fade left >
        <div className="sub-title">
          Whether as independent as our online programs or as hands-on as our in-person sessions, we're here for you every
          step of the way
      </div>
      </Fade>
      <div className="inperson-workout">
        <Rotate top>
          <div className="left-section">
            <InPersonImageGroup
              phoneOne={CONSTANTS.phoneFour}
              phoneTwo={CONSTANTS.phoneFive}
              largeImage={CONSTANTS.inPersonLargeImage}
            />
          </div>
        </Rotate>
        <Fade right >
          <div className="right-section">
            <div className="title">In-person workouts</div>
            <div className="para">
              With over a decade of experience, Omni-Active® trainers know how to get you the results you want. After an
              initial consultation, we will match you with a trainer based on your goals, personality, and skill set. With
              this hands-on approach and higher level of accountability, reaching your goals is inevitable.
          </div>
            <div className="para">
              Message your trainer directly, sign-in for sessions, and even receive workouts for the days you aren’t with
              us all within our industry changing app.
          </div>
            <div className="line">You get all 3 types</div>
            <div className="types">
              <div className="type">In-Person</div>
              <div className="type">Virtual</div>
              <div className="type">Online</div>
            </div>
            <Link to="/programs" onClick={handleTab}>
              <CustomButton type={CONSTANTS.ROUNDED_TYPE}>View Details</CustomButton>
            </Link>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default InPersonWorkout;
